/** The imported file keeps its extension for export; the card label omits it. */
export function getSourcePhotoDisplayName(filename: string): string {
  return filename.replace(/\.[^.]+$/, '')
}

export function sanitizeBatchPhotoName(name: string): string {
  return name.replace(/[\\/:*?"<>|]/g, '').slice(0, 100)
}

export function getNextGeneratedPhotoName(sourceName: string, usedNames: ReadonlySet<string>): string {
  const stem = sourceName.replace(/(?:\s*\(\d+\))+$/, '')
  let ordinal = 2
  while (usedNames.has(`${stem} (${ordinal})`)) ordinal += 1
  return `${stem} (${ordinal})`
}
